// document.addEventListener("DOMContentLoaded", function () {
//           window.klaviyo = window.klaviyo || [];
          
//           klaviyo.init({
//               account: "LFESdL",
//               platform: "shopify"
//           });

//           klaviyo.enable("backinstock", { 
//               trigger: {
//                   product_page_text: "Notify Me When Available",
//                   product_page_class: "klaviyo-bis-trigger", 
//                   replace_anchor: true 
//               },
//               modal: (() => {
//                   const lang = window.langify?.locale?.language_code;
                  
//                   const base = {
//                       headline: "{product_name}",
//                       footer_content: '',
//                       drop_background_color: "#000",
//                       background_color: "#fff",
//                       text_color: "#222",
//                       button_text_color: "#fff",
//                       button_background_color: "#51c96d",
//                       close_button_color: "#ccc",
//                       error_background_color: "#fcd6d7",
//                       error_text_color: "#C72E2F",
//                       success_background_color: "#d3efcd",
//                       success_text_color: "#1B9500",
//                       additional_styles:
//                           "@import url('//www.minimalist.ae/cdn/shop/t/1023/assets/klaviyo-bis-modal.css?v=156023835702106952561764071094'); body { display: flex; align-items: center;justify-content: center;height: 100%; text-transform: uppercase;}button.btn {text-transform: uppercase;border-radius: 8px;}div#klaviyo-bis-modal { padding: 0 15px;}"
//                   };

//                   if (lang === 'en') {
//                       base.body_content = "Register to receive a notification when this item comes back in stock.";
//                       base.email_field_label = "Email";
//                       base.button_label = "Notify me when available";
//                       base.subscription_success_label = "You're in! We'll let you know when it's back.";
//                   } else {
//                       base.body_content = "قم بالتسجيل لتلقي الإشعارات عند توفر هذا المنتج.";
//                       base.email_field_label = "البريد الإلكتروني";
//                       base.button_label = "أخبرني عندما يتوفر هذا المنتج";
//                       base.subscription_success_label = "اهلا بك! سنخبرك عندما يعود.";
//                   }

//                   return base;
//               })()
//           });

//           console.log("Klaviyo Back-in-Stock initialized.");

//           // Ensure button triggers correctly
//           document.querySelectorAll(".klaviyo-bis-trigger").forEach(button => {
//               button.addEventListener("click", function (event) {
//                   event.preventDefault();
//                   console.log("Back-in-stock button clicked.");
//               });
//           });

//           // Fetch user IP asynchronously without blocking execution
//           fetch("https://api.ipify.org?format=json")
//               .then(response => response.json())
//               .then(data => {
//                   let ipInput = document.getElementById("ip_address");
//                   if (ipInput) ipInput.value = data.ip;
//               })
//               .catch(err => console.error("IP fetch error:", err));
// });

//notifyButton start
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.klaviyo-bis-trigger');
  if (!btn) return;

  e.preventDefault();
  var productTitle =btn.closest('.product-info__block-list')?.querySelector('.product-title')?.textContent.trim();

  window.openNotifyPopup(productTitle);
});
//notifyButton end
    if(window.langify?.locale?.language_code === 'ar') {

      document.addEventListener("DOMContentLoaded", function () {
          setTimeout(function () { 
              let emailInput = document.querySelector(".klaviyo-form input[type='email']");
              if (emailInput) {
                  emailInput.placeholder = emailInput.placeholder.replace(
                      "Enter your email address", 
                      "أدخل عنوان بريدك الالكتروني"
                  );
              }
          }, 15000);
      });
     }


function buildPswpVideoHTML(videoUrl) {
  return (
    '<div class="pswp-video-wrapper" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">' +
      '<video autoplay muted playsinline loop webkit-playsinline preload="auto" style="max-width:100%;max-height:100%;">' +
        '<source src="' + videoUrl + '#t=0.001" type="video/mp4">' +
      '</video>' +
    '</div>'
  );
}
if ($(window).width() < 769) {

  var mySwiper = new Swiper('.swiper-gallery', {
    loop: true,
    slidesPerView: 1,
    paginationClickable: true,
    resizeObserver: true,
    observer: true,
    observeParents: true,
    spaceBetween: 0,

    navigation: {
      nextEl: '.pgallery-swiper-button-next',
      prevEl: '.pgallery-swiper-button-prev',
    },

    scrollbar: {
      el: '.pgallery-swiper-scrollbar',
      draggable: true,
      snapOnRelease: true,
      hide: false,
    },

    breakpoints: {
      1920: { slidesPerView: 1, spaceBetween: 0 },
      1028: { slidesPerView: 2, spaceBetween: 0 },
      480: { slidesPerView: 1, spaceBetween: 0 }
    }
  });


  var initPhotoSwipeFromDOM = function(gallerySelector) {

    var parseThumbnailElements = function(el) {

      var thumbElements = el.childNodes,
          numNodes = thumbElements.length,
          items = [],
          figureEl,
          linkEl,
          size,
          item;

      for (var i = 0; i < numNodes; i++) {

        figureEl = thumbElements[i];

        if (figureEl.nodeType !== 1) continue;

        linkEl = figureEl.children[0];

        // Liquid sets data-media-type="video"|"image"|"external_video"
        var mediaType = linkEl.getAttribute("data-media-type") || linkEl.getAttribute("data-type");
        var href = linkEl.getAttribute("href") || "";
        var looksLikeVideo = mediaType === "video" || /\.(mp4|webm|mov)(\?.*)?$/i.test(href);

        if (looksLikeVideo) {

          // VIDEO SLIDE — html mode only (no src/w/h)
          var videoUrl = linkEl.getAttribute("data-video") || href;

          item = {
            html: buildPswpVideoHTML(videoUrl),
            pid: "video-" + i,
            el: figureEl
          };

          // Use the poster as a low-res placeholder while transitioning in
          var posterImg = linkEl.querySelector("img");
          if (posterImg) {
            item.msrc = posterImg.getAttribute("src");
          }

        } else {

          // IMAGE SLIDE — standard PhotoSwipe item
          size = (linkEl.getAttribute("data-size") || "2000x2000").split("x");

          item = {
            src: href,
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10),
            el: figureEl
          };

          if (linkEl.children.length > 0) {
            var firstChildImg = linkEl.querySelector("img");
            if (firstChildImg) {
              item.msrc = firstChildImg.getAttribute("src");
            }
          }
        }

        // CAPTION (optional)
        if (figureEl.children.length > 1 && figureEl.children[1].innerHTML) {
          item.title = figureEl.children[1].innerHTML;
        }

        items.push(item);
      }

      return items;
    };


    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };


    var onThumbnailsClick = function(e) {

      e = e || window.event;

      e.preventDefault
        ? e.preventDefault()
        : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      var clickedListItem = closest(eTarget, function(el) {
        return el.tagName && el.tagName.toUpperCase() === "DIV";
      });

      if (!clickedListItem) return;

      var clickedGallery = clickedListItem.parentNode,
          childNodes = clickedGallery.childNodes,
          numChildNodes = childNodes.length,
          nodeIndex = 0,
          index;

      for (var i = 0; i < numChildNodes; i++) {

        if (childNodes[i].nodeType !== 1) continue;

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }

        nodeIndex++;
      }

      if (index >= 0) {
        openPhotoSwipe(index, clickedGallery);
      }

      return false;
    };


    var photoswipeParseHash = function() {

      var hash = window.location.hash.substring(1),
          params = {};

      if (hash.length < 5) {
        return params;
      }

      var vars = hash.split("&");

      for (var i = 0; i < vars.length; i++) {

        if (!vars[i]) continue;

        var pair = vars[i].split("=");

        if (pair.length < 2) continue;

        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };


    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {

      var pswpElement = document.querySelectorAll(".pswp")[0],
          gallery,
          options,
          items;

      items = parseThumbnailElements(galleryElement);

      options = {
        closeEl: true,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: true,
        shareEl: true,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,

        galleryUID: galleryElement.getAttribute("data-pswp-uid"),

        getThumbBoundsFn: function(index) {

          var thumbnail = items[index].el && items[index].el.getElementsByTagName("img")[0];
          if (!thumbnail) return null;
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();

          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      if (fromURL) {

        if (options.galleryPIDs) {

          for (var j = 0; j < items.length; j++) {

            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }

        } else {
          options.index = parseInt(index, 10) - 1;
        }

      } else {
        options.index = parseInt(index, 10);
      }

      if (isNaN(options.index)) return;

      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }

      gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      gallery.init();

      // VIDEO PLAYBACK CONTROL
      var pauseAllPswpVideos = function() {
        document.querySelectorAll('.pswp .pswp-video-wrapper video').forEach(function(v){
          try { v.pause(); } catch (err) {}
        });
      };

      var playActiveVideo = function() {
        pauseAllPswpVideos();
        var currentItem = gallery.currItem;
        if (currentItem && currentItem.container) {
          var video = currentItem.container.querySelector('video');
          if (video) {
            video.currentTime = 0;
            var p = video.play();
            if (p && typeof p.catch === 'function') { p.catch(function(){}); }
          }
        }
      };

      gallery.listen('afterChange', playActiveVideo);
      gallery.listen('initialZoomInEnd', playActiveVideo);
      gallery.listen('close', pauseAllPswpVideos);
      gallery.listen('destroy', pauseAllPswpVideos);

      gallery.listen("unbindEvents", function() {

        var getCurrentIndex = gallery.getCurrentIndex();

        mySwiper.slideTo(getCurrentIndex, false);
      });
    };


    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {

      galleryElements[i].setAttribute("data-pswp-uid", i + 1);

      galleryElements[i].onclick = onThumbnailsClick;
    }


    var hashData = photoswipeParseHash();

    if (hashData.pid && hashData.gid) {

      openPhotoSwipe(
        hashData.pid,
        galleryElements[hashData.gid - 1],
        true,
        true
      );
    }
  };

  initPhotoSwipeFromDOM(".gallery_mobile_slider .my-gallery");

} else {

  "use strict";

  !function(i){

    var t = [];

    i(".product-gallery__image-list")
      .find("figure")
      .each(function(){

        var a = i(this).find("a").first();

        if (!a.length) { return; }

        var mediaType = a.attr("data-media-type") || a.attr("data-type");
        var href = a.attr("href") || "";
        var looksLikeVideo = mediaType === "video" || /\.(mp4|webm|mov)(\?.*)?$/i.test(href);

        var e;

        if (looksLikeVideo) {

          // VIDEO SLIDE — html mode only (no src/w/h)
          var videoUrl = a.attr("data-video") || href;

          e = {
            html: buildPswpVideoHTML(videoUrl),
            title: a.data("caption")
          };

          var posterImg = a.find("img").first();
          if (posterImg.length) {
            e.msrc = posterImg.attr("src");
          }

        } else {

          // IMAGE SLIDE
          e = {
            src: href,
            w: a.data("width") || 1200,
            h: a.data("height") || 1200,
            title: a.data("caption")
          };
        }

        t.push(e);
      });


    i(".product-gallery__image-list a").click(function(a){

      a.preventDefault();

      var e = i(".pswp")[0];

      var s = {
        index: i(this).parent("figure").index(),
        bgOpacity: 0.85,
        showHideOpacity: true
      };

      var gallery = new PhotoSwipe(
        e,
        PhotoSwipeUI_Default,
        t,
        s
      );

      gallery.init();

      // VIDEO PLAYBACK CONTROL
      var pauseAllPswpVideos = function() {
        document.querySelectorAll('.pswp .pswp-video-wrapper video').forEach(function(v){
          try { v.pause(); } catch (err) {}
        });
      };

      var playActiveVideo = function() {
        pauseAllPswpVideos();
        var currentItem = gallery.currItem;
        if (currentItem && currentItem.container) {
          var video = currentItem.container.querySelector('video');
          if (video) {
            video.currentTime = 0;
            var p = video.play();
            if (p && typeof p.catch === 'function') { p.catch(function(){}); }
          }
        }
      };

      gallery.listen('afterChange', playActiveVideo);
      gallery.listen('initialZoomInEnd', playActiveVideo);
      gallery.listen('close', pauseAllPswpVideos);
      gallery.listen('destroy', pauseAllPswpVideos);
    });

  }(jQuery);
}

     // if ($(window).width() < 769) {
// var mySwiper = new Swiper('.swiper-gallery', {
// loop: true, slidesPerView: 1, paginationClickable: true,resizeObserver: true,  observer: true, observeParents: true,  spaceBetween: 0, navigation: { nextEl: '.pgallery-swiper-button-next', prevEl: '.pgallery-swiper-button-prev', }, 
// scrollbar: { el: '.pgallery-swiper-scrollbar', draggable: true, snapOnRelease: true, hide: false,   },
// breakpoints: { 1920: { slidesPerView: 1, spaceBetween: 0 }, 1028: { slidesPerView: 2, spaceBetween: 0 }, 480: { slidesPerView: 1, spaceBetween: 0 } } });
// var initPhotoSwipeFromDOM = function(gallerySelector) {
// var parseThumbnailElements = function(el) {
// var thumbElements = el.childNodes, numNodes = thumbElements.length, items = [], figureEl, linkEl, size, item;
// for (var i = 0; i < numNodes; i++) { figureEl = thumbElements[i]; if (figureEl.nodeType !== 1) { continue; }
// linkEl = figureEl.children[0];
// size = linkEl.getAttribute("data-size").split("x");
// item = { src: linkEl.getAttribute("href"), w: parseInt(size[0], 10), h: parseInt(size[1], 10) };
// if (figureEl.children.length > 1) {item.title = figureEl.children[1].innerHTML;}
// if (linkEl.children.length > 0) {item.msrc = linkEl.children[0].getAttribute("src");}
// item.el = figureEl; items.push(item); } return items; };
// var closest = function closest(el, fn) {return el && (fn(el) ? el : closest(el.parentNode, fn)); };
// var onThumbnailsClick = function(e) { e = e || window.event; e.preventDefault ? e.preventDefault() : (e.returnValue = false); var eTarget = e.target || e.srcElement;
// var clickedListItem = closest(eTarget, function(el) { return el.tagName && el.tagName.toUpperCase() === "DIV"; });
// if (!clickedListItem) { return; }
// var clickedGallery = clickedListItem.parentNode, childNodes = clickedListItem.parentNode.childNodes, numChildNodes = childNodes.length, nodeIndex = 0, index;
// for (var i = 0; i < numChildNodes; i++) { if (childNodes[i].nodeType !== 1) { continue; }
// if (childNodes[i] === clickedListItem) { index = nodeIndex; break; }
// nodeIndex++; }
// if (index >= 0) { openPhotoSwipe(index, clickedGallery); } return false; };
// var photoswipeParseHash = function() { var hash = window.location.hash.substring(1), params = {}; if (hash.length < 5) { return params; }
// var vars = hash.split("&");for (var i = 0; i < vars.length; i++) {if (!vars[i]) {continue;}
// var pair = vars[i].split("="); if (pair.length < 2) { continue; }
// params[pair[0]] = pair[1]; }
// if (params.gid) { params.gid = parseInt(params.gid, 10); } return params; };
// var openPhotoSwipe = function( index, galleryElement, disableAnimation, fromURL ) {
// var pswpElement = document.querySelectorAll(".pswp")[0],gallery,options,items;items = parseThumbnailElements(galleryElement);
// options = {
// closeEl: true,captionEl: true,fullscreenEl: true,zoomEl: true,shareEl: true,counterEl: false,arrowEl: true,preloaderEl: true,
// galleryUID: galleryElement.getAttribute("data-pswp-uid"), getThumbBoundsFn: function(index) { var thumbnail = items[index].el.getElementsByTagName("img")[0],
// pageYScroll = window.pageYOffset || document.documentElement.scrollTop, rect = thumbnail.getBoundingClientRect(); return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }; } };
// if (fromURL) { if (options.galleryPIDs) { for (var j = 0; j < items.length; j++) { if (items[j].pid == index) { options.index = j; break; } }
// } else { options.index = parseInt(index, 10) - 1; }
// } else { options.index = parseInt(index, 10); }
// if (isNaN(options.index)) { return; }
// if (disableAnimation) { options.showAnimationDuration = 0; }
// gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
// gallery.init();
// gallery.listen("unbindEvents", function() { var getCurrentIndex = gallery.getCurrentIndex(); mySwiper.slideTo(getCurrentIndex, false); }); };
// var galleryElements = document.querySelectorAll(gallerySelector);
// for (var i = 0, l = galleryElements.length; i < l; i++) { galleryElements[i].setAttribute("data-pswp-uid", i + 1); galleryElements[i].onclick = onThumbnailsClick; }
// var hashData = photoswipeParseHash();
// if (hashData.pid && hashData.gid) { openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true); } };
// initPhotoSwipeFromDOM(".gallery_mobile_slider .my-gallery");
// }else{
// "use strict";
// !function(i){
// var t=[];i(".product-gallery__image-list").find("figure").each(function(){
// var a=i(this).find("a"),e={src:a.attr("href"),w:a.data("width"),h:a.data("height"),title:a.data("caption")};t.push(e)}),i(".product-gallery__image-list a").click(function(a){a.preventDefault();
// var e=i(".pswp")[0],s={index:i(this).parent("figure").index(),bgOpacity:0.85,showHideOpacity:true};var gallery = new PhotoSwipe(e,PhotoSwipeUI_Default,t,s).init();gallery.init();
// })
// }
// (jQuery);
// }

$(document).on("click",".product-thumsDesktop div",function(){ 
var i=$(this).find("img").data("imageid");
$(".product-gallery__image-list .prod_img").removeClass("img_show"),
$(".product-gallery__image-list .prod_img").each(function(){
$(this).data("imageid")==i&&$(this).addClass("img_show")
})
});

$(".galary-slides .li_st").click(function () {
        var t = $(this).find("img").attr("src");
        $("#small-slider-zoom").html(" "),
          $("#small-slider-zoom").prepend('<img id="mobile_zoom_effect" src="' + t + '" />' ),
          $('#mobile_zoom_effect').wrap('<span class="zoom" style="display:inline-block;"></span>').css('display', 'block') .parent().zoom({ on:'click',touch:'true', zoomWindowWidth:1200, zoomWindowHeight:1200});
          $(".model_img").css("display", "block");
});
$(".close_popup").click(function () {
        $(".model_img").css("display", "none"),
          $("#small-slider-zoom").prepend(""),
          $("#small-slider-zoom").find("span").remove();
});

$(document).ready(function () {
  const intervalId = setInterval(() => {
    if (!location.pathname.includes('coffee')) return;

    const swatches = document.querySelectorAll(
      '.product-info__block-item[data-block-type="custom-variant-picker"] .variant-picker__option-values label.block-swatch'
    );
   
    // If swatches exist, stop the interval
    if (swatches.length > 0) {      
     if(document.querySelector('.product-info__block-item[data-block-type=custom-variant-picker] .variant-picker__option-values label.block-swatch').classList.contains('is-disabled')){ 
    
      document .querySelector( '.product-info__block-item[data-block-type="custom-variant-picker"] .variant-picker__option-values:has(.is-disabled) input' ).click(); 
          clearInterval(intervalId);
     }
    }
  }, 10); // runs every 1 second
});

// JS on scroll 

(function() {
  if (window.innerWidth >= 999) {
    const button_sticky_bar = document.querySelector('safe-sticky .button_val_preorder');
    const trigger_sticky_bar = document.querySelector('safe-sticky .button_val_preorder .klaviyo-bis-trigger');
    const sticky_sticky_bar = document.querySelector('product-sticky-bar');
    if (!button_sticky_bar || !sticky_sticky_bar) return;
    function checkPosition() {
      if (trigger_sticky_bar && window.getComputedStyle(trigger_sticky_bar).display !== 'none') { sticky_sticky_bar.classList.remove('is-visible');  return;  }
          if(sticky_sticky_bar.classList.contains('is-visible')){ return;}
      const rect_sticky_bar = button_sticky_bar.getBoundingClientRect();
      const shouldShow_sticky_bar = rect_sticky_bar.bottom < 0;
      sticky_sticky_bar.classList.toggle('is-visible', shouldShow_sticky_bar);
    }

    window.addEventListener('scroll', checkPosition, { passive: true });
  }
})();

// REcent view

  document.addEventListener("DOMContentLoaded", function() {
    // Disable instant.page for recently viewed product links
    document.querySelectorAll(
      "recently-viewed-products a, .shopify-section--recently-viewed-products a"
    ).forEach(function(link) {
      link.setAttribute("data-no-instant", "");
    });
  });

  // Also handle dynamically loaded recently viewed products
  const recentObserver = new MutationObserver(function() {
    document.querySelectorAll(
      "recently-viewed-products a:not([data-no-instant])"
    ).forEach(function(link) {
      link.setAttribute("data-no-instant", "");
    });
  });

  recentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });